import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import { HiOutlineLightBulb } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { SlGraduation } from "react-icons/sl";
import { LiaAwardSolid } from "react-icons/lia";
import { useState } from "react";
import AddEducationModal from "./common/add-education-modal";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";

const ProfileEducationInformationScreen = () => {
  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => setShowWork(false);
  const handleShowWK = () => setShowWork(true);
  const [NavigateTo] = useCustomNavigate();
  const { user } = useSelector((state: RootState) => state.authSlice);
  const prevHandler = () => {
    if (user && user?.role === "jobseeker") {
      NavigateTo(AppRoute.JOBSEEKER_ADDED_WORK_EXPERIENCE);
    } else if (user && user?.role === "localagents") {
      NavigateTo(AppRoute.AGENT_ADDED_WORK_EXPERIENCE);
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && (
                  <AgentTopHeadScreen />
                )}{" "}
                <div className="profile-account-details-holder rightInnerScroll common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <div className="stepbar">
                                  <ul>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 1</p>
                                        <h4>About You</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 2</p>
                                        <h4>Experience</h4>
                                      </a>
                                    </li>
                                    <li className="inprogress">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <SlGraduation />
                                          </span>
                                        </div>
                                        <p>Step 3</p>
                                        <h4>Education</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <LiaAwardSolid />
                                          </span>
                                        </div>
                                        <p>Step 4</p>
                                        <h4>Achievements</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <HiOutlineLightBulb />
                                          </span>
                                        </div>
                                        <p>Step 5</p>
                                        <h4>Skills</h4>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <h3>Enrich Your Profile:</h3>
                              <h4>Include Your Academic Journey.</h4>
                              <div className="flex-btn d-flex">
                                <Button
                                  className="btn btn-primary"
                                  onClick={prevHandler}
                                >
                                  Prev
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  onClick={handleShowWK}
                                >
                                  Add Education{" "}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* Add Education Information model*/}
      <AddEducationModal
        show={showWork}
        onClose={handleCloseWK}
        // isBulkEdit = {isBulkEdit}
        // isSingleEdit = {isSingleEdit}
        // getExperienceList = {experienceList}
      />
      {/* Add Education Information model*/}
    </>
  );
};
export default ProfileEducationInformationScreen;
